import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_back_button = _resolveComponent("back-button")!
  const _component_AccountEditor = _resolveComponent("AccountEditor")!
  const _component_Permission = _resolveComponent("Permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Nav),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_back_button),
      _createVNode(_component_AccountEditor, {
        edit: true,
        slug: _ctx.slug
      }, null, 8, ["slug"]),
      _createVNode(_component_Permission, { slug: _ctx.slug }, null, 8, ["slug"])
    ])
  ], 64))
}